import { createSlice } from '@reduxjs/toolkit';

interface initialStateInterFace {
	error: any;
	loading: boolean;
	listingLoading: boolean;
	collectionList: Array<any>;
	currentPage: number;
	currentPageItem: number;
	count: number;
	countItem: number;
	collectionDetails: any;
}

const initialState: initialStateInterFace = {
	error: '',
	loading: false,
	listingLoading: false,
	collectionList: [],
	currentPage: 1,
	currentPageItem: 1,
	countItem: 0,
	count: 0,
	collectionDetails: null
};
const collectionSlice = createSlice({
	name: 'collectionSlice',
	initialState,
	reducers: {
		updateCurrentPage(state, action) {
			state.currentPage = action.payload;
		},
		setLoading(state, action) {
			state.loading = action.payload;
		}
	}
});
export const { updateCurrentPage, setLoading } = collectionSlice.actions;
export default collectionSlice.reducer;
